import React, { useState, useEffect } from 'react';
import { CheckCircle2, FileText, CreditCard, ArrowLeft, Download, Lock, Loader2 } from 'lucide-react';
import CheckoutPayment from '../../components/CheckoutPayment'; 
import api from '../../api/axios'; 

export default function PaymentView({ shipment, breakdown }) {
  const [paymentResult, setPaymentResult] = useState(null);
  const [isGuideReady, setIsGuideReady] = useState(false);
  const [isCheckingEstatus, setIsCheckingEstatus] = useState(false);

  // 🔄 LÓGICA DE VERIFICACIÓN
  useEffect(() => {
    let intervalId;

    if (paymentResult?.status === 'approved' && !isGuideReady) {
      console.log("🔍 Iniciando sondeo para el tracking:", shipment?.tracking_number);
      setIsCheckingEstatus(true);

      const verificar = async () => {
        try {
          const response = await api.get(`/shipments/${shipment?.tracking_number}/status`);
          console.log("📡 Respuesta del servidor:", response.data);
          
          if (response.data.is_paid) {
            console.log("✅ ¡Confirmado! Desbloqueando botón.");
            setIsGuideReady(true);
            setIsCheckingEstatus(false);
            clearInterval(intervalId);
          }
        } catch (error) {
          console.error("❌ Error en la petición de estatus (esto es normal si el server aún procesa):", error);
        }
      };

      intervalId = setInterval(verificar, 3000);
      verificar();
    }

    return () => clearInterval(intervalId);
  }, [paymentResult, isGuideReady, shipment?.tracking_number]);

  if (paymentResult) {
    const isApproved = paymentResult.status === 'approved';
    const idTienda = paymentResult.tienda_exacta || paymentResult.method_id;

    return (
      <div className="w-full max-w-lg mx-auto mt-10">
        <div className="bg-white dark:bg-gradient-to-b dark:from-[#590000] dark:to-[#780000] rounded-3xl p-10 shadow-2xl text-center border-t-8 border-[#CE010B] transition-all">
          
          {isApproved ? (
            <div className="flex flex-col items-center">
              <CheckCircle2 className="text-green-500 mb-6" size={64} />
              <h2 className="text-3xl font-black text-gray-900 dark:text-white uppercase">¡Pago Exitoso!</h2>
              
              {/* 🛡️ RENDERIZADO PROTEGIDO */}
              {isGuideReady ? (
                <a 
                  href={`${import.meta.env.VITE_BACKEND_URL}/api/shipments/download/${shipment?.tracking_number}`}
                  target="_blank" 
                  rel="noreferrer"
                  className="mt-8 w-full bg-green-600 text-white font-bold py-4 rounded-xl flex items-center justify-center gap-2 shadow-lg uppercase"
                >
                  <Download size={20} /> DESCARGAR GUÍA AHORA
                </a>
              ) : (
                <div className="mt-8 w-full bg-gray-200 text-gray-400 font-bold py-4 rounded-xl flex items-center justify-center gap-2 border-2 border-dashed border-gray-300 cursor-not-allowed">
                  <Lock size={20} /> 
                  {isCheckingEstatus ? "CONFIRMANDO PAGO..." : "GUÍA BLOQUEADA"}
                  <Loader2 size={18} className="animate-spin ml-2" />
                </div>
              )}

              <button onClick={() => window.location.reload()} className="mt-8 text-xs font-bold text-gray-400 uppercase">
                Hacer otro envío
              </button>
            </div>
          ) : (
            /* ... (Resto del código de OXXO igual) ... */
            <div className="flex flex-col items-center">
               <FileText className="text-blue-500 mb-6" size={64} />
               <h2 className="text-3xl font-black text-gray-900 dark:text-white uppercase">Pago en Espera</h2>
               <p className="mt-4 text-gray-500">Imprime tu ticket para pagar en sucursal.</p>
               <a href={paymentResult.external_resource_url} target="_blank" rel="noreferrer" className="mt-8 w-full bg-[#CE010B] text-white font-bold py-4 rounded-xl flex items-center justify-center gap-2 uppercase">
                 VER TICKET <CreditCard size={20} />
               </a>
            </div>
          )}
        </div>
      </div>
    );
  }

  /* ... (Resto del componente igual) ... */
  return (
    <div className="w-full max-w-6xl mx-auto mb-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="p-8 bg-gray-100 rounded-3xl shadow-lg">
                <h3 className="font-black uppercase mb-6 flex items-center gap-2"><FileText size={20}/> Estado de Cuenta</h3>
                <div className="flex justify-between font-bold text-2xl border-t-2 pt-4 border-dashed border-gray-400">
                    <span>Total</span>
                    <span className="text-[#CE010B]">${displayBreakdown.total}</span>
                </div>
            </div>
            <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
                <CheckoutPayment shipmentData={shipment} amountToPay={displayBreakdown.total} onPaymentSuccess={(res) => setPaymentResult(res)} />
            </div>
        </div>
    </div>
  );
}